import React from 'react'

const MaterialWarning = () => {
  return (
    <div className='svg-icon material-warning-icon'>
      <svg  data-name="Icon material-warning" xmlns="http://www.w3.org/2000/svg" width="30.656" height="26.476" viewBox="0 0 30.656 26.476">
        <path id="Icon_material-warning-2" data-name="Icon material-warning" d="M1.5,29.476H32.156L16.828,3ZM18.222,25.3H15.435V22.509h2.787Zm0-5.574H15.435V14.148h2.787Z" transform="translate(-1.5 -3)" fill="#f44236"/>
      </svg>
    </div>
  )
}

export default MaterialWarning
